import * as angular from 'angular';

import { Rule } from '../../models/';
import { IRequestService } from '../../services';

export interface IBulkEditService {
    bulkEdit(onlyVisible: boolean, replace: boolean, rules: Rule[], guidList: string[], type: any): angular.IPromise<any>;
}

export class BulkEditService implements IBulkEditService {
    static serviceId = 'bulkEditService';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    bulkEdit(onlyVisible: boolean, replace: boolean, rules: Rule[], guidList: string[], type: any): angular.IPromise<any> {
        const data = {
            applyAll: !onlyVisible,
            replace: replace,
            editRules: rules,
            guidList: guidList,
            objectType: type
        };

        return this._requestService.postAtV1<number>('bulkEdit', data);
    }
}